<div class="icard">
  <p class="user"><mat-icon>comment</mat-icon> {{ comment.user?.fullname }}</p>
  <p class="text">{{ comment.comment }}</p>
  <p class="date">{{ date }}</p>
</div>
